import theme from '../../../theme';

export const AMPDateRangePickerSx = {
    calendar: {
        alignItems: 'center',
        [theme.breakpoints.down('md')]: {
            '.rdrCalendarWrapper': {
                fontSize: theme.spacing(10 / 8),
            },
        },
        '.rdrDefinedRangesWrapper': {
            display: 'none',
        },
        // Lock month height so the calendar doesn't jump when navigating between
        // months with 4/5/6 week rows. Always reserve space for 6 rows + weekdays.
        '.rdrMonth': {
            minHeight: '21em',
        },
        '.rdrDays': {
            minHeight: '18em',
            alignContent: 'flex-start',
        },
    },
};
